<template>
    <div class="main-container">
        <!-- 页面标题 -->
        <div class="page-header">
            <h1 class="page-title">任务配置</h1>
        </div>
        <div class="content">
            <div>
                <form class="form-group-list-form">
                    <div>
                    </div>
                    <div>
                        <button class="btn btn-primary" @click="add">新增</button>
                    </div>
                </form>
            </div>
            <div style="margin-top: 1rem;">
                <Tablelist
                        :showCheckbox="showCheckbox"
                        :list="list"
                        :columns="tableColumns"
                        :totalSize="totalSize"
                        :totalPages="totalPages"
                        :pageNum="pageNum"
                        :pageSize="pageSize"
                        @action="handleAction"
                        @page-change="onChange"
                >
                    <template #template-type="{ item }">
                        <DataDictFinder dictType="taskType" :dictValue="String(item.type)" />
                    </template>
                </Tablelist>
            </div>
        </div>
        <Edit :visible="visible" :detail="detail" @cancel="cancel" @refresh="getList" />
    </div>
</template>
<script>
import Edit from "./edit.vue";
import request from "@/api/request";
import Tablelist from "@/components/water-affairs-style/table-list.vue";
function fetchList() {
    return request({
        url: "/model-analysis/inspect/task/remark/list",
    });
}

function remove(params) {
    return request({
        url: "/model-analysis/inspect/task/remark/delete/" + params.id,
    });
}
export default {
    components: {Tablelist,Edit},
    data() {
        return {
            detail: {},
            visible: false,
            form: {},
            loading: false,
            totalSize: 0,
            totalPages: 0,
            pageNum: 1,
            pageSize: 10,
            list:[
                {id:1,name:'-',remark:'-'}
            ],
            showCheckbox:false,
            total: 0,
            tableColumns: [
                {
                    key: 'type',
                    title: '任务类型',
                    field: 'type',
                    infotype: 'template'
                },
                {
                    key: 'remark',
                    title: '任务说明',
                    field: 'remark',
                    infotype: 'text'
                },
                {
                    key: 'actions',
                    title: '操作',
                    render: {
                        view: false, edit: true, delete: true,audit:false
                    }
                }
            ]
        };
    },

    mounted() {
        this.getList();
    },

    methods: {
        getList() {
            this.loading = true;
            fetchList()
                .then((res) => {
                    if (Array.isArray(res.list)) {
                        this.list = Object.freeze(res.list);
                        this.totalSize = res.totalSize;
                        this.totalPages = res.totalPages;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        deleteText(text) {
            const that = this;
            this.$confirm({
                title: "确认要删除吗？",
                onOk() {
                    const hide = that.$message.loading("删除中...", 0);
                    remove({ id: text.id, category: text.category })
                        .then(() => {
                            that.getList();
                        })
                        .finally(() => {
                            hide();
                        });
                },
            });
        },
        cancel() {
            this.visible = false;
            this.detail = {};
        },
        onChange(pagination) {
            this.pageNum  = pagination;
            this.pageSize = 10;
            this.getList();
        },
        add() {
            this.detail = {};
            this.visible =  !this.visible;
        },
        edit(text) {
            this.detail = text;
            this.visible = !this.visible;
        },
        handleAction(actionInfo) {
            console.log("actionInfo====",actionInfo)
            const { type, item, id } = actionInfo;
            switch(type) {
                case 'view':
                    this.getview(id);
                    break;
                case 'edit':
                    this.getEdit(item);
                    break;
                case 'audit':
                    this.getAudit(item);
                    break;
                case 'delete':
                    this.getDelete(item);
                    break;
            }
        },
        getview(){},
        getEdit(text){
            this.edit(text)
        },
        getAudit(){},
        getDelete(text){
            this.deleteText(text)
        },
    },
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
    background: #0a0e27;
    color: #fff;
    overflow-x: hidden;
}

/* 主内容区 */
.main-container {
    padding:2rem 0;
    width: 80%;
    margin: auto;
}

/* 页面标题 */
.page-header {
    margin-bottom: 2rem;
}

.page-title {
    font-size: 2rem;
    margin-bottom: 0.5rem;
    background: linear-gradient(135deg, #fff, #00ff96);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
.content{
    background: rgba(20, 35, 70, 0.5);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 2rem;
    margin-bottom: 1.5rem;
}
.form-group-list-form{
    display: flex;
    justify-content: space-between;
}
.form-group-list{
    display: flex;
    justify-content: start;
}
.form-group {
    display: flex;
    align-items: center;
    margin: 0 10px;
}

.form-label {
    display: block;
    color: #94a3b8;
    font-size: 0.9rem;
    margin: 0 1rem;
}

.form-input {
    padding: 0.75rem 1rem;
    background: rgba(10, 20, 40, 0.6);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 10px;
    color: #fff;
    font-size: 1rem;
    transition: all 0.3s ease;
}

.form-input:focus {
    outline: none;
    border-color: #00ff96;
    background: rgba(10, 20, 40, 0.8);
    box-shadow: 0 0 20px rgba(0, 255, 150, 0.2);
}

.form-input::placeholder {
    color: #64748b;
}

.btn {
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    text-decoration: none;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    cursor: pointer;
    border: none;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0 0.8rem 0 0;
}

.btn-primary {
    background: linear-gradient(135deg, #00ff96, #00d4ff);
    color: #0a0e27;
    font-weight: 600;
}

.btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(0, 255, 150, 0.3);
}

.btn-secondary {
    background: rgba(20, 35, 70, 0.5);
    border: 1px solid rgba(0, 255, 150, 0.3);
    color: #00ff96;
}

.btn-secondary:hover {
    background: rgba(0, 255, 150, 0.1);
    border-color: #00ff96;
}
.filter-select {
    padding: 0.75rem 1rem;
    background: rgb(14 27 52);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 6px;
    color: #fff;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 90%;
}

.filter-select:focus {
    outline: none;
    border-color: #00ff96;
    box-shadow: 0 0 10px rgba(0, 255, 150, 0.2);
}
</style>